import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Tabs } from '../ui';
import DeckManager from '../learn/DeckManager';
import StatsPanel from '../learn/StatsPanel';

/**
 * `/missions/decks` — the flashcard decks behind the card-backed missions.
 *
 * `DeckManager` and `StatsPanel` were built and working but unreachable (no
 * route pointed at them). They are mounted here unchanged; the Mission Center
 * is their new home. The statistics live behind a second tab rather than on
 * the Mission Center itself so review counts and streaks never sit next to the
 * mastery levels and get mistaken for a competence claim (spec §3.3
 * principle 4).
 */
export function DecksView() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="etch-view">
      <div className="etch-column" data-width="wide">
        <header className="etch-page-header">
          <div className="etch-page-header__title">
            <span className="etch-eyebrow">{t('nav.missions')}</span>
            <h1>{t('learn.decks')}</h1>
            <p>{t('missions.decksSubtitle')}</p>
          </div>
          <div className="etch-page-header__actions">
            <Button variant="ghost" size="compact" onClick={() => navigate('/missions')}>
              {t('missions.backToCenter')}
            </Button>
          </div>
        </header>

        <Tabs
          ariaLabel={t('learn.decks')}
          items={[
            { id: 'decks', label: t('learn.decks'), panel: <DeckManager /> },
            { id: 'stats', label: t('learn.stats'), panel: <StatsPanel /> },
          ]}
        />
      </div>
    </div>
  );
}

export default DecksView;
